/* eslint-disable no-shadow */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  submitRemovalFromPsl,
  cancelRemovalFromPsl,
} from "../../actions/preferredSuppliersListActions";
import Loading from "../shared/loaders/Loading";
import Button from "../shared/button/Button";
import {
  Backdrop,
  ModalWrapper,
  Title,
  TitleText,
  Body,
  Form,
  Label,
  Field,
  TextInput,
  Error,
  CloseButton,
  ButtonsWrapper,
} from "./styles/remove-from-psl-modal-styles";

export class RemoveFromPslModal extends Component {
  state = {
    message: "",
    messageError: "",
  };

  setMessage = (e) => {
    const message = e.target.value;
    this.setState({
      message,
      messageError:
        message.length > 2000 ? "Message cannot exceed 2000 characters" : "",
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { submitRemovalFromPsl, removeFromPslData } = this.props;
    const { preferredSupplier } = removeFromPslData;
    const { message, messageError } = this.state;
    if (messageError) {
      return;
    }
    submitRemovalFromPsl({
      preferredSupplier,
      message,
    });
  };

  render() {
    const {
      removeFromPslData,
      removeFromPslLoading,
      errors,
      cancelRemovalFromPsl,
    } = this.props;
    const { message, messageError } = this.state;
    const { preferredSupplier } = removeFromPslData;

    return (
      <Backdrop className="animated fadeIn" id="remove-from-psl-modal">
        <ModalWrapper className="animated delay-1 fadeInDown">
          <Title>
            <TitleText>Remove from PSL</TitleText>
            <CloseButton
              onClick={() => {
                cancelRemovalFromPsl();
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
          </Title>
          <Body>
            {removeFromPslLoading && <Loading white fontSize="medium" />}
            <Form onSubmit={this.handleSubmit}>
              <Label>
                You are about to remove{" "}
                <strong>{preferredSupplier.recruiter.name}</strong> from your
                PSL.
                <br />
                This will not disengage them from any existing jobs, but it will
                mean they need your approval for new engagement requests.
                <br />
                <br />
                Are you sure you want to remove this recruiter from your PSL?
              </Label>
              <Field>
                <TextInput
                  data-test-id="remove-from-psl-message"
                  placeholder="Enter your message..."
                  value={message}
                  onChange={this.setMessage}
                />
                {/* <Error>
                  {errors && errors.message && "Message can't be blank"}
                </Error> */}
                {messageError && <Error>{messageError}</Error>}
                {/* {errors && errors.message && (
                  <Error>"Message can't be blank"</Error>
                )} */}
              </Field>
              <ButtonsWrapper>
                <Button
                  secondary
                  buttonName="Cancel"
                  onClickAction={() => {
                    cancelRemovalFromPsl();
                  }}
                />
                {/* <Button primary buttonName="Submit" type="submit" /> */}
                <Button
                  primary
                  buttonName="Submit"
                  type="submit"
                  disabled={messageError || message.length === 0}
                />
              </ButtonsWrapper>
            </Form>
          </Body>
        </ModalWrapper>
      </Backdrop>
    );
  }
}

RemoveFromPslModal.propTypes = {
  submitRemovalFromPsl: PropTypes.func.isRequired,
  removeFromPslData: PropTypes.shape({
    preferredSupplier: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      createdAt: PropTypes.string,
      recruiterId: PropTypes.number,
      activeEngagementCount: PropTypes.number,
      recruiter: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  removeFromPslLoading: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    message: PropTypes.string,
  }),
  cancelRemovalFromPsl: PropTypes.func.isRequired,
};

RemoveFromPslModal.defaultProps = {
  errors: PropTypes.shape({
    message: PropTypes.isNull,
  }),
};

const mapStateToProps = (state) => ({
  removeFromPslLoading: state.preferredSuppliersList.removeFromPslLoading,
  isEmployer: state.preferredSuppliersList.isEmployer,
  errors: state.preferredSuppliersList.errors,
});

export default connect(mapStateToProps, {
  submitRemovalFromPsl,
  cancelRemovalFromPsl,
})(RemoveFromPslModal);
